import Slider from './src/slider'
export default Slider


// WEBPACK FOOTER //
// ./src/components/slider/index.js